module.exports = __webpack_public_path__ + "img/img2.bf5cd84b.jpg";